import React from "react";

export const cards = {
  id: 0,
  list: [],
};

export const CardContext = React.createContext(cards);
